"use client";

import { Heading, HeadingProps } from "@chakra-ui/react";

interface AppHeadingTextProps {
  text: string;
  size: HeadingProps["size"];
  className: string;
}

export function AppHeadingText({ text, size, className }: AppHeadingTextProps) {
  return (
    <Heading
      size={size}
      className={className}
    >
      {text}
    </Heading>
  );
}
